import { render, staticRenderFns } from "./AddBeautyForm.vue?vue&type=template&id=05924655&"
import script from "./AddBeautyForm.vue?vue&type=script&lang=js&"
export * from "./AddBeautyForm.vue?vue&type=script&lang=js&"
import style0 from "./AddBeautyForm.vue?vue&type=style&index=0&id=05924655&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports